// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3gDZ9","inner":"Footer_inner__12NFr"};